import {
  createKpiTileItem,
  checkForNA,
  appendPercentage,
  formatValueWithMiddlewares,
  applySuffix,
} from '../../../v2/utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { totalNoOfErrors, totalNoOfErrorsDelta } = data;
    return createKpiTileItem(
      'Total Number Of Errors',
      formatValueWithMiddlewares(Math.abs(totalNoOfErrors), [
        checkForNA,
        applySuffix,
      ]).toString(),
      totalNoOfErrorsDelta
        ? {
            isPositiveValue: totalNoOfErrorsDelta <= 0,
            text: formatValueWithMiddlewares(Math.abs(totalNoOfErrorsDelta), [
              checkForNA,
              appendPercentage,
            ]).toString(),
            sideLabel: '',
            showArrow: totalNoOfErrorsDelta !== 0,
            arrowReversed: true,
          }
        : []
    );
  },
};
